export enum ClientSourceTypeEnum {
  JetSmarter = '1',
  XOJet = '2',
}
